import React from 'react';
import { msg } from 'constants/message';
import Datetime from 'react-datetime';
import moment from 'moment';
import { ShowIf } from 'components/utils';
import * as CONFIG from 'constants/config';
import { validatable } from 'components/utils';
import 'moment/locale/vi';

class DatePicker extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      isValid: true,
      value: this.props.value,
      startDate: this.props.startDate,
      endDate: this.props.endDate,
      message: ''
    }
  }

  onChange(e) {
    let inputDate = e;
    if (e._d) {
      inputDate = e._d;
    }

    this.setState({
      value: inputDate
    });
    this.props.onChange(inputDate)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.startDate != this.state.startDate) {
      this.setState({
        startDate: nextProps.startDate
      });
    }

    if (nextProps.endDate != this.state.endDate) {
      this.setState({
        endDate: nextProps.endDate
      });
    }

    if (nextProps.value != this.props.value) {
      this.setState({
        value: nextProps.value
      });
    }

    if (!this.state.isValid && nextProps.require && !nextProps.value) {
      this.setState({
        isValid: false,
        message: this.props.requireMessage
      });
    } else if (nextProps.value && !moment(nextProps.value, CONFIG.DateFormat).isValid()) {
      this.setState({
        isValid: false,
        message: this.props.errMessage
      });
    } else if ((!nextProps.require && moment(nextProps.value, CONFIG.DateFormat).isValid()) || (nextProps.require && nextProps.value && moment(nextProps.value, CONFIG.DateFormat).isValid())) {
      this.setState({
        isValid: true
      });
    }
  }

  classNames() {
    if (this.state.isValid) {
      return 'calendar_icon';
    } else {
      return 'calendar_icon pt-datepicker-danger';
    }
  }

  validate() {
    if (this.props.value != this.state.value) {
      this.props.onChange(this.state.value);
    }
    let isValid = (typeof this.state.value == 'string' && this.state.value.trim() == '') || moment(this.state.value, CONFIG.DateFormat).isValid();

    this.setState({ isValid });

    if (this.props.require && (typeof this.state.value == 'string' && this.state.value.trim() == '')) {
      this.setState({
        // TODO: Need to check if date string is valid, eg: '20/07/32ab'
        isValid: false,
        message: this.props.requireMessage
      });
      this.input.focus();
      return false;
    } else if (!isValid) {
      this.setState({
        // TODO: Need to check if date string is valid, eg: '20/07/32ab'
        isValid: false,
        message: this.props.errMessage
      });
      this.input.focus();
      return false;
    } else {
      return true;
    }
  }

  handleBlur() {
    setTimeout(() => {
      this.validate();
    }, 500)
  }

  render() {
    return (
      <div className={this.props.className + ' mb18'}>
        <ShowIf condition={this.props.label != ''}>
          <label className="ip-label">
            {this.props.label}
            <ShowIf condition={this.props.require}>
              <span className="text-required">&nbsp;*</span>
            </ShowIf>
          </label>
        </ShowIf>
        <div className="pt-label mb0">
          <Datetime
            className={this.classNames()}
            onChange={this.onChange.bind(this)}
            dateFormat={this.props.dateFormat}
            closeOnSelect={!this.props.timeFormat ? true : false}
            timeFormat={this.props.timeFormat}
            value={this.state.value}
            isValidDate={this.props.isValidDate.bind(this)}
            onBlur={this.handleBlur.bind(this)}
            inputProps={{ placeholder: this.props.placeholder, maxLength: this.props.maxLength, name: this.props.name, autoComplete: 'off', disabled: this.props.disabled }}
            locale="vi"
            renderMonth={(props, month) => <td {...props}>T {month + 1}</td>}
          />
          <input className='hidden-input' ref={(input) => { this.input = input }} />
        </div>
        <ShowIf condition={!this.state.isValid}>
          <div className="pt-form-helper-text">
            {this.state.message}
          </div>
        </ShowIf>
      </div>
    )
  }
}

function isValidDate(current) {
  let validBefore = true,
    validAfter = true;

  if (moment(this.state.startDate, CONFIG.DateFormat).isValid()) {
    validBefore = !current.isBefore(moment(this.state.startDate, CONFIG.DateFormat));
  }

  if (moment(this.state.endDate, CONFIG.DateFormat).isValid()) {
    validAfter = !current.isAfter(moment(this.state.endDate, CONFIG.DateFormat));
  }

  return validBefore && validAfter;
}

DatePicker.defaultProps = {
  className: 'input-group',
  label: '',
  timeFormat: false,
  dateFormat: CONFIG.DateFormat,
  placeholder: 'dd/MM/yyyy',
  maxLength: 10,
  value: '',
  require: false,
  errMessage: msg.dateInvalid,
  requireMessage: msg.messageDefault,
  onChange: function () {
    console.log('Please assign onChange method')
  },
  startDate: '',
  endDate: '',
  isValidDate: isValidDate,
  name: '',
  disabled: false
}

export default validatable(DatePicker);



// WEBPACK FOOTER //
// ./src/components/tt-forms/common/DatePicker.jsx